/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PathSegment } from '../models/PathSegment';

export class BucketPathPartitionSpec {
  /**
  * The path separator character
  */
  'separator'?: string;
  /**
  * Ordered list of path segments defining the partition structure
  */
  'segments': Array<PathSegment>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "separator",
      "baseName": "separator",
      "type": "string",
      "format": ""
    },
    {
      "name": "segments",
      "baseName": "segments",
      "type": "Array<PathSegment>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return BucketPathPartitionSpec.attributeTypeMap;
  }

  public constructor() {
  }
}

